import React from 'react';
import axios from 'axios';
import { Button, Card, Descriptions, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { SystemApi } from '../../../services/Api';

interface PanelSignitureProps {
    trans: (key: string) => string;
}

interface PanelSignitureState {
    signTime: string;
    expireTime: string;
    leftTime: number;
    leftTimeStr: string;
    loading: boolean;
}

export default class PanelSigniture extends React.Component<PanelSignitureProps, PanelSignitureState> {
    state: PanelSignitureState = {
        signTime: '',
        expireTime: '',
        leftTime: 0,
        leftTimeStr: '',
        loading: false,
    };

    updateCertInfo = (certInfo: any) => {
        this.setState({
            signTime: certInfo?.signTime || '',
            expireTime: certInfo?.expireTime || '',
            leftTime: Number(certInfo?.leftTime || 0),
            leftTimeStr: certInfo?.leftTimeStr || '',
        });
    };

    refreshSignitureInfo = async () => {
        const lang = localStorage.getItem('lang') || 'zh_CN';
        this.setState({ loading: true });

        try {
            const response = await axios.post(SystemApi.GET_CERT_EXPIRE_TIME, {
                lang: lang.split('_')[0],
            });

            if (response.data?.data) {
                this.updateCertInfo(response.data.data);
            }
        } catch (error) {
            console.error('PanelSigniture.refreshSignitureInfo()', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { trans: t } = this.props;
        const { loading } = this.state;

        return (
            <Card
                title={t('signitureMgmt')}
                extra={
                    <Button
                        type="text"
                        icon={<ReloadOutlined />}
                        loading={loading}
                        onClick={this.refreshSignitureInfo}
                    >
                        {t('refresh')}
                    </Button>
                }
            >
                <Descriptions bordered column={1} size="small">
                    <Descriptions.Item label={t('signTime')}>
                        {this.state.signTime}
                    </Descriptions.Item>
                    <Descriptions.Item label={t('expireTime')}>
                        {this.state.expireTime}
                    </Descriptions.Item>
                    <Descriptions.Item label={t('leftTime')}>
                        {this.state.leftTimeStr}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        );
    }
}
